const CLIENTS_BASE = '/api/clients';
const DOCUMENTS_BASE = '/api/documents';

export const getClientDocuments = async (authenticatedFetch, clientId) => {
  const response = await authenticatedFetch(`${CLIENTS_BASE}/${clientId}/documents`);
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to fetch documents', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to fetch documents');
    err.code = errorData.code || null;
    throw err;
  }
  return response.json();
};

export const uploadDocument = async (authenticatedFetch, clientId, file, documentType, holdingId, notes) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('document_type', documentType);
  if (holdingId) formData.append('holding_id', holdingId);
  if (notes) formData.append('notes', notes);

  const response = await authenticatedFetch(`${CLIENTS_BASE}/${clientId}/documents`, {
    method: 'POST',
    body: formData,
    // Do NOT set Content-Type — browser sets it with boundary for multipart
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to upload document', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to upload document');
    err.code = errorData.code || null;
    throw err;
  }
  return response.json();
};

export const getDocumentDetail = async (authenticatedFetch, documentId) => {
  const response = await authenticatedFetch(`${DOCUMENTS_BASE}/${documentId}`);
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to fetch document', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to fetch document');
    err.code = errorData.code || null;
    throw err;
  }
  return response.json();
};

export const confirmExtraction = async (authenticatedFetch, documentId, extractedData) => {
  const response = await authenticatedFetch(`${DOCUMENTS_BASE}/${documentId}/confirm`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ extracted_data: extractedData }),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to confirm extraction', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to confirm extraction');
    err.code = errorData.code || null;
    throw err;
  }
  return response.json();
};

export const getDownloadUrl = async (authenticatedFetch, documentId) => {
  const response = await authenticatedFetch(`${DOCUMENTS_BASE}/${documentId}/download`);
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to get download URL', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to get download URL');
    err.code = errorData.code || null;
    throw err;
  }
  return response.json();
};

export const applyExtraction = async (authenticatedFetch, documentId, holdingId, fieldsToApply) => {
  const response = await authenticatedFetch(`${DOCUMENTS_BASE}/${documentId}/apply`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ holding_id: holdingId, fields_to_apply: fieldsToApply }),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to apply extraction', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to apply extraction');
    err.code = errorData.code || null;
    throw err;
  }
  return response.json();
};

export const deleteDocument = async (authenticatedFetch, documentId) => {
  const response = await authenticatedFetch(`${DOCUMENTS_BASE}/${documentId}`, {
    method: 'DELETE',
  });
  if (!response.ok && response.status !== 204) {
    const errorData = await response.json().catch(() => ({ detail: 'Failed to delete document', code: 'INTERNAL_ERROR' }));
    const err = new Error(errorData.detail || 'Failed to delete document');
    err.code = errorData.code || null;
    throw err;
  }
};
